import { render, staticRenderFns } from "./Pelicula.vue?vue&type=template&id=7514dc56"
import script from "./Pelicula.vue?vue&type=script&lang=js"
export * from "./Pelicula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports